import { render, staticRenderFns } from "./upload-dicom.vue?vue&type=template&id=3b469bd0"
import script from "./upload-dicom.vue?vue&type=script&lang=js"
export * from "./upload-dicom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports